import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    if (!this.supported) {
      element.querySelectorAll("img[data-src]").forEach((image) => {
        this.loadImage(image);
      });
      return;
    }

    this.mutations = new MutationObserver(this.onMutation.bind(this));
    this.mutations.observe(this.element, { attributes: false, childList: true, subtree: true });

    this.intersections = new IntersectionObserver(this.onIntersection.bind(this), {
      rootMargin: "100px 0px",
      threshold: 0.01,
    });

    this.observeElement(this.element);
  }

  disconnect() {
    if (!this.supported) return;
    this.mutations.disconnect();
    this.intersections.disconnect();
  }

  observeElement(element) {
    element.querySelectorAll("img[data-src]").forEach((image) => {
      this.intersections.observe(image);
    });
  }

  loadImage(image) {
    image.onload = () => {
      image.removeAttribute("data-src");
    };
    image.src = image.dataset.src;
  }

  onMutation(entries) {
    entries.forEach((entry) => {
      entry.addedNodes.forEach((node) => {
        if (typeof node.querySelectorAll === "function") this.observeElement(node);
      });
    });
  }

  onIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0) {
        this.intersections.unobserve(entry.target);
        this.loadImage(entry.target);
      }
    });
  }

  get supported() {
    return "MutationObserver" in window && "IntersectionObserver" in window;
  }
}
